import { useEffect, useState } from "react";
import { Button, Col, Row, Select, Space } from "antd";
import PayoutTransactionsTable from "./PayoutTransactionsTable";
import usePayouts from "hooks/finance/usePayouts";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import useUsers from "hooks/userManagement/useUsers";

export default function PayoutTransactionsPage() {
  const {
    payouts,
    setPayouts,
    fetchUserPayouts,
    fetchSentPayouts,
    fetchReceivedPayouts,
    loading,
  } = usePayouts();

  const { searchUserProfiles } = useUsers(0, 20, null, true, { autoFetch: false });

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [transferType, setTransferType] = useState("ALL");

  useEffect(() => {
    if (!selectedUserId) {
      setPayouts([]);
      return;
    }

    if (transferType === "SENT") {
      fetchSentPayouts(selectedUserId);
    } else if (transferType === "RECEIVED") {
      fetchReceivedPayouts(selectedUserId);
    } else {
      fetchUserPayouts(selectedUserId);
    }
  }, [
    selectedUserId,
    transferType,
    fetchUserPayouts,
    fetchSentPayouts,
    fetchReceivedPayouts,
  ]);

  const handleSearchUser = async (value) => {
    if (!value) return setUserOptions([]);

    try {
      const users = await searchUserProfiles(value);

      setUserOptions(
        users.map((u) => ({
          label: `${u.firstName} ${u.lastName} (${u.email})`,
          value: u.id,
        })),
      );
    } catch (err) {
      console.error("Failed to search users", err);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2 mt-2 gap-3">
        <WidgetSectionTitle
          icon="money-bill-alt"
          title="Payout Transactions"
          subtitle="View all payout transfers between users"
          className="mb-3 mt-3 flex-1"
        />
      </div>

      {/* filter bar */}
      <Row gutter={[10, 10]} style={{ marginBottom: 16, alignItems: "center" }}>
        <Col>
          <Select
            showSearch={{
              filterOption: false,
              onSearch: handleSearchUser,
            }}
            placeholder="Search and select user"
            allowClear
            onChange={async (val) => {
              if (!val) {
                setSelectedUserId(null);
                setTransferType("ALL");
                await fetchUserPayouts();
              } else {
                setSelectedUserId(val);
              }
            }}
            options={userOptions}
            style={{ width: 300 }}
          />
        </Col>
        <Col style={{ marginLeft: "auto" }}>
          <Space>
            <Button
              type={transferType === "ALL" ? "primary" : "default"}
              onClick={() => setTransferType("ALL")}
            >
              All Transfers
            </Button>

            <Button
              type={transferType === "SENT" ? "primary" : "default"}
              onClick={() => setTransferType("SENT")}
            >
              Sent
            </Button>

            <Button
              type={transferType === "RECEIVED" ? "primary" : "default"}
              onClick={() => setTransferType("RECEIVED")}
            >
              Received
            </Button>
          </Space>
        </Col>
      </Row>

      <PayoutTransactionsTable payouts={payouts} loading={loading} />
    </div>
  );
}
